import { RL_NAVIGATION_ITEM_LABELS } from "../header.routes";
import { PAGE_PATH } from "../../../path";
import { DEFAULT_YARA_URL_PARAMS } from "../../yara/dashboard/consts";

export const getYaraPageReload = (
  item: string,
  pathname: string,
  urlParams: string
) => {
  if (item !== RL_NAVIGATION_ITEM_LABELS.YARA) return false;

  return pathname === PAGE_PATH.YARA && urlParams !== DEFAULT_YARA_URL_PARAMS;
};
